export const SMART_BANNER_DISABLED_PATHS = [
  '/appointments/confirmation',
]
